// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"IJ-z","smallCardRow":"JJ-z","largeCardRow":"KJ-z","productSearchRow":"LJ-z","curatedRow":"MJ-z"};